import { useContext } from "react";

import { SWContext } from "@/context";

export const useSW = () => useContext(SWContext);
